/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import styled from '@emotion/styled'

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.secondary.base};
  display: block;
  padding: 8px;
  transition: background-color 200ms ease-out;
  text-decoration: none;

  &:focus {
    outline: 1px solid ${({ theme }) => theme.secondary.medium};
  }

  &:hover {
    background-color: ${({ theme }) => theme.secondary.light};
  }
`

const NavSelectOption = ({ children, id, index, to, ...props }) => (
  <li id={id} role='option'>
    <StyledLink to={to} {...props} data-index={index} data-id={id}>
      {children}
    </StyledLink>
  </li>
)

NavSelectOption.propTypes = {
  children: PropTypes.any.isRequired,
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onFocus: PropTypes.func.isRequired,
  to: PropTypes.string.isRequired,
}

export default NavSelectOption
